import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const MinaFakturor = lazy(() => import("@/pages/mina-sidor/Fakturor"));

export const Route = createFileRoute("/mina-sidor/fakturor")({
  head: () => ({
    meta: [
      { title: "Mina fakturor » Mina sidor | Elmarknad.se" },
      { name: "description", content: "Ladda upp dina elfakturor och få en AI-analys med sparförslag." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <MinaFakturor />,
});
